@if (isDagrofa) {
  <div class="back-wrapper">
    <button class="back unstyled-button" onclick="history.back()"><mat-icon svgIcon="left_arrow"></mat-icon></button>
  </div>
}
<ol class="breadcrumb" dir="rtl">
  @for (breadcrumb of breadcrumbs; track $index) {
    <li class="breadcrumb-item">
      <a [routerLink]="breadcrumb.url" queryParamsHandling="merge">
        {{ breadcrumb.label | titlecase }}
      </a>
    </li>
  }
</ol>
